import Pusher from 'pusher-js';

let client: Pusher | null = null;
let clientToken: string | null = null;

const getBroadcastingAuthEndpoint = () => {
  const apiUrl = import.meta.env.VITE_API_URL.replace(/\/$/, '');
  return `${apiUrl}/v1/broadcasting/auth`;
};

// Multiple features (notifications, admin items, ...) share one Pusher
// connection. Reuse it for the same token instead of reconnecting, which
// would drop channel bindings other features already set up.
export function initPusher(token: string): Pusher {
  if (client && clientToken === token) {
    return client;
  }
  if (client) {
    client.disconnect();
  }
  client = new Pusher(import.meta.env.VITE_PUSHER_APP_KEY, {
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    // WebSocket-only: the SockJS/HTTP fallback transports have been
    // observed silently degrading to a broken polling session (server
    // returns 404 on xhr_send) instead of failing loudly, so events stop
    // arriving with no visible error. Failing fast on a blocked native
    // WebSocket is more diagnosable, and UI polling covers the gap when
    // realtime is unavailable.
    enabledTransports: ['ws', 'wss'],
    channelAuthorization: {
      transport: 'ajax',
      endpoint: getBroadcastingAuthEndpoint(),
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  });
  clientToken = token;
  return client;
}

export function disconnectPusher(): void {
  client?.disconnect();
  client = null;
  clientToken = null;
}
